<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title">
                若此騎士無法承接您的任務
            </div>
            <div class="subtitle">
                *此操作僅能變更一次*
            </div>
            <div class="selects">
                <div class="option" @click.stop="mode = 'missing'">
                    <p-radio name="mode" value="missing" v-model="mode"/>
                    <div class="text">
                        我只要這位騎士，不然就<span>暫停配對</span>
                    </div>
                </div>
                <div class="option" @click.stop="mode = 'dispatching'">
                    <p-radio name="mode" value="dispatching" v-model="mode"/>
                    <div class="text">
                        我可以接受<span>隨機配對</span>其它的騎士
                    </div>
                </div>
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click="onCancel">
                取消
            </div>
            <div class="confirm button" @click="onConfirm">
                確定
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from "../modal/Modal";
    import RadioButton from "../RadioButton";
    import Swal from "sweetalert2";
    import {mapActions} from "vuex";

    export default {
        name: "ChangeDesignateModeModal",
        components: {
            'p-modal': Modal,
            'p-radio': RadioButton
        },
        data() {
            return {
                display: false,
                mode: 'missing',
                orderId: 0,
                organMode: '',
            };
        },
        methods: {
            onCancel() {
                this.mode = 'missing';
                this.display = false;
            },
            onConfirm() {
                this.display = false;
                if (this.orderId <= 0 || this.mode == this.organMode) {
                    return;
                }

                let payload = {
                    id: this.orderId,
                    data: {
                        designate_type: this.mode,
                    }
                };

                this.putOrder(payload).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            },
            show(orderId, organMode) {
                this.orderId = orderId;
                this.organMode = organMode;
                this.display = true;
            },
            ...mapActions(['putOrder'])
        }
    }
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .subtitle {
        color: rgba(244,67,54,1);
        font-size: 12px;
        line-height: 17px;
        text-align: center;
    }

    .selects {
        .option {
            user-select: none;
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 25px;

            .text {
                margin-left: 5px;

                span {
                    color: #339933;
                }
            }
        }
    }

    .buttons {
        display: flex;

        .button {
            width: 100%;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;
            color: #9b9b9b;

            &.confirm {
                color: #339933;
            }
        }
    }
</style>